export default __webpack_public_path__ + "static/media/ionnyk-app4.0452fc47.png";